import { LOCAL_STORAGE_AUTH_KEY, getAuth } from '@harbortouch/alexandria-utilities';
import axios, { type AxiosError } from 'axios';

import { EventEmitter } from 'events';
import { environmentConfig } from '../environment.const';
import { getDataOwnerId } from '../state/app-state';

export const localStorageEventEmitter = new EventEmitter();

export const clearLocalStorage = () => {
	localStorage.removeItem(LOCAL_STORAGE_AUTH_KEY);
	localStorageEventEmitter.emit('change');
};

export const lhHttpClient = axios.create({
	baseURL: environmentConfig().lhHost,
});

export const steHttpClient = axios.create({
	baseURL: environmentConfig().steHost,
});

lhHttpClient.interceptors.response.use(
	(response) => response,
	async (error: AxiosError) => {
		if (error.response?.status === 401) {
			clearLocalStorage();
		}

		return Promise.reject(error);
	},
);

steHttpClient.interceptors.response.use(
	(response) => response,
	async (error: AxiosError) => {
		if (error.response?.status === 401) {
			clearLocalStorage();
		}

		return Promise.reject(error);
	},
);

lhHttpClient.interceptors.request.use(
	(config) => {
		const authenInfo = getAuth()?.authenticated;
		// eslint-disable-next-line no-param-reassign
		config.headers['x-access-token'] = authenInfo?.token;
		return config;
	},
	(error) => Promise.reject(error as Error),
);

steHttpClient.interceptors.request.use(
	(config) => {
		const authenInfo = getAuth()?.authenticated;
		// eslint-disable-next-line no-param-reassign
		config.headers['x-access-token'] = authenInfo?.token;
		// eslint-disable-next-line no-param-reassign
		config.headers['x-data-owner-id'] = getDataOwnerId();
		return config;
	},
	(error) => Promise.reject(error as Error),
);
